/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';
import { Typography, CardMedia, Link } from '@one-thd/sui-atomic-components';
import { InfoFilled } from '@one-thd/sui-icons';
import { LAYOUT_TYPES } from '../../utils/utils';
import { CustomTooltip } from './subcomponents/common/CustomTooltip';
import { isMobile } from '../../helpers/price-helper';

const getPreferredPricingDetails = () => {
  return (
    <div>
      <span>
        {'As a Pro Xtra member, you are qualified for\xA0'}
        <Link className="sui-text-sm sui-underline" href="https://www.homedepot.com/c/pro_preferred_pricing">
          Preferred Pricing
        </Link>.
      </span>
    </div>
  );
};

export const PreferredPricingBadge = ({
  channel,
  type,
  align = 'start',
  showPreferredPricingBadgeToolTip = false,
  isListView = false
}) => {

  let flexClasses = 'sui-flex sui-items-center sui-content-center sui-mb-1';
  if (align === 'end' || (isListView && isMobile(channel))) {
    flexClasses = 'sui-flex sui-justify-end';
  }
  const badgeSize = type === LAYOUT_TYPES.DETAILED ? '24px' : '16px';
  const typeVariant = type === LAYOUT_TYPES.DETAILED ? 'h5' : 'h6';

  return (
    <div className={flexClasses}>
      <div className="sui-mr-2">
        <CardMedia
          src="https://assets.thdstatic.com/images/v1/preferred-pricing-icon.svg"
          style={{ width: `${badgeSize}`, height: `${badgeSize}` }}
          alt="Preferred Pricing Badge"
          title="Preferred Pricing" />
      </div>
      <Typography variant={typeVariant} weight="display">
        PREFERRED PRICING
      </Typography>
      {showPreferredPricingBadgeToolTip && !isListView && (
        <div className="sui-ml-2">
          <CustomTooltip
            PricingIcon={InfoFilled}
            color="info-strong"
          >{getPreferredPricingDetails()}
          </CustomTooltip>
        </div>
      )}
    </div>
  );
};

PreferredPricingBadge.propTypes = {
  channel: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
  align: PropTypes.string,
  showPreferredPricingBadgeToolTip: PropTypes.bool,
  isListView: PropTypes.bool
};
